module.exports = __webpack_public_path__ + "static/img/strength.fc63460d.png";